// updateTriggerPrivateUnlockState.js
'use strict';
import getOperationData from '../selector/getOperationData.js';
import getMeData from '../selector/getMeData.js';
import getGoalData from '../selector/getGoalData.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';

import setIsPrivateStreamUnlocked from '../action/setIsPrivateStreamUnlocked.js';
import setPrivateStreamAutoPayment from '../action/setPrivateStreamAutoPayment.js';
import fetchPrivateShowLeaderboard from '../action/fetchPrivateShowLeaderboard.js';

import getCurrentUnixTimestamp from '../resource/getCurrentUnixTimestamp.js';

/**
 * Update trigger private unlock state
 * @kind action
 * @param {string} {streamId} - stream id.
 * @param {string} {goalId} - goal id.
 * @param {boolean} {needFetchGoalBreakdown} - need fetch goal breakdown.
 * @return {Promise} Action promise.
 */
const updateTriggerPrivateUnlockState =
  ({ streamId, goalId, needFetchGoalBreakdown = false } = {}) =>
  async (dispatch, getState) => {
    if (!streamId || !goalId) return dispatch({ type: '' });

    const meId = getMeData(getState(), 'id');

    if (needFetchGoalBreakdown && meId != null) {
      const nowUnix = getCurrentUnixTimestamp({
        offsetSeconds: getTimestampOffset(getState(), Accuracy.SECOND),
      });
      await dispatch(
        fetchPrivateShowLeaderboard({
          streamId,
          fundingId: goalId,
          userIds: [meId],
          unixTimestamp: nowUnix,
        })
      );
    }

    const isPrivateStreamUnlocked = getOperationData(
      getState(),
      ['liveStream', 'paid', streamId],
      'isPrivateStreamUnlocked'
    );
    const hasProgress =
      (getGoalData(getState(), [goalId, 'breakdown', meId], 'progress') || 0) >
      0;

    if (hasProgress !== isPrivateStreamUnlocked) {
      dispatch(
        setIsPrivateStreamUnlocked({
          streamId,
          isPrivateStreamUnlocked: hasProgress,
        })
      );
      // Clear auto payment if not unlocked
      if (!hasProgress) {
        dispatch(setPrivateStreamAutoPayment({ streamId, isEnabled: false }));
      }
    }
  };

export default updateTriggerPrivateUnlockState;
